<template>
  <SysDialog
    v-model="DIALOG_ATIVO"
    :titulo="`Relatório ${relatorio.title}`"
    txt-botao="Gerar relatório"
    @click:primary="gerarRelatorio"
  >
    <SysSegmentoAutocomplete
      v-model="filtros.segmentos"
      label="Segmentos"
      outlined
      multiple
      hide-details
      class="mt-4"
    />

    <SysFornecedorAutocomplete
      v-model="filtros.fornecedores"
      label="Fornecedores"
      outlined
      multiple
      :ids-segmento="filtros.segmentos"
      hide-details
      class="mt-4"
    />

    <form
      :action="URL_RELATORIO"
      method="post"
      target="_blank"
      ref="submit-form-relatorio-produtos-de-combinados"
    >
      <input type="text" hidden name="filtros.segmentos" :value="filtros.segmentos" />
      <input type="text" hidden name="filtros.fornecedores" :value="filtros.fornecedores" />
    </form>
  </SysDialog>
</template>

<script>
import Mixin from "@/components/Relatorios/Mixin";
import SysSegmentoAutocomplete from "@/components/utils/crud/SysSegmentoAutocomplete";
import SysFornecedorAutocomplete from "@/components/utils/crud/SysFornecedorAutocomplete";

export default {
  name: "ProdutosDeCombinados",
  mixins: [Mixin],
  components: {
    SysFornecedorAutocomplete,
    SysSegmentoAutocomplete
  },
  data: () => ({
    filtros: {
      segmentos: [],
      fornecedores: [],
    }
  }),
  computed: {
    GET_BASE_URL() {
      if (window.__APP_CONFIG__.VUE_APP_MULTI_DATABASE === "true" || window.__APP_CONFIG__.VUE_APP_MULTIPLAS_BASE_URL === "true") {
        return localStorage.baseUrl||window.__APP_CONFIG__.VUE_APP_URL_BASE;
      }

      return window.__APP_CONFIG__.VUE_APP_URL_BASE;
    },
    URL_RELATORIO() {
      return this.GET_BASE_URL + '/api/relatorios/produtos-de-combinados';
    }
  },
  methods: {
    gerarRelatorio() {
      this.$refs['submit-form-relatorio-produtos-de-combinados'].submit();
      this.DIALOG_ATIVO = false;
    }
  }
}
</script>

<style scoped>

</style>
